<script lang="ts">
  import { page } from '@inertiajs/svelte'

  type MetaTag = {
    tagName: string
    headKey: string
    innerContent?: string
    name?: string
    property?: string
    content?: string
  }

  let metaTags = $derived((page.props._inertia_meta || []) as MetaTag[])
</script>

<svelte:head>
  {#each metaTags as tag (tag.headKey)}
    {#if tag.tagName === 'title'}
      <title>{tag.innerContent}</title>
    {:else if tag.tagName === 'meta'}
      {#if tag.name}
        <meta name={tag.name} content={tag.content || ''} />
      {:else if tag.property}
        <meta property={tag.property} content={tag.content || ''} />
      {/if}
    {/if}
  {/each}
</svelte:head>
